import { render, staticRenderFns } from "./card_best_cider.vue?vue&type=template&id=4a6cd633&scoped=true"
import script from "./card_best_cider.vue?vue&type=script&lang=js"
export * from "./card_best_cider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6cd633",
  null
  
)

export default component.exports